import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: "root" })
export class FunctionUsageService {
  private service = 'FunctionUsageService';

  constructor(private http: HttpClient) {

  }

  public getListByUser(): any {
    return this.http.get(`api/${this.service}/listByUser`);
  }

  public increaseCountOfFunctionByCategoryIdAndFunctionCode(categoryId: number, functionCode: string) {
    return this.http.get<number>(`api/${this.service}/IncreaseCountOfFunctionByCategoryIdAndFunctionCode/${categoryId}/${functionCode}`);
  }

  public updateFunctionUsage(disciplineId: number, functionCode: string) {
    let categoryId = 0;
    if (disciplineId === 1) { categoryId = 4; }
    else if (disciplineId === 2) { categoryId = 5 }
    else if (disciplineId === 7) { categoryId = 6 }
    else if (disciplineId === 13) { categoryId = 3 }

    this.increaseCountOfFunctionByCategoryIdAndFunctionCode(categoryId, functionCode).subscribe();
  }
}
